module.exports = __webpack_public_path__ + "static/media/office.359e9f75.svg";